export default __webpack_public_path__ + "static/media/mute.8d607d7e.svg";